module.exports = {
  LIFTIGNITER_INVENTORY_FIELD: ['url', 'id', 'description', 'social_head', 'published_time', 'authors', 'title', 'topics', 'section'],
}



// WEBPACK FOOTER //
// ./config/liftigniter.js